//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'
import { OpDescr } from '../core/op-descr'

export class OpReportType implements IReferenceType, IOpChangeState, IJsonSerializable {
 
    public idReportType: number
    public name: string
    public idDescr: number
    public descr: OpDescr
    public opState: Enums.OpChangeState

    constructor(opObj: any) {
        this.fromJSON(opObj)        
    }

    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdReportType
    }
    public getReferenceKey(): number {
        return this.idReportType
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {
                this.idReportType = opObj.IT
                this.name = opObj.N
                this.idDescr = opObj.I
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
                this.opState = opObj.O
            } else {
                this.idReportType = opObj.ID_REPORT_TYPE
                this.name = opObj.NAME
                this.idDescr = opObj.ID_DESCR
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.opState = opObj.OpState
            }
        }
    }
    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                IT: this.idReportType,
                N: this.name,
                I: this.idDescr,
                D: this.descr ? new OpDescr(compressed) : null,
                O: this.opState,
                __IC: 1
            }
        } else {
            return {
                ID_REPORT_TYPE: this.idReportType,
                NAME: this.name,
                ID_DESCR: this.idDescr,
                _Descr: this.descr ? new OpDescr(compressed) : null,
                OpState: this.opState
            }
        }
    }
    
    public toString() {
        if (this.descr)
            return this.descr.description
        else
            return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpReportType[]): JQueryPromise<OpReportType[]> {
        var defered = $.Deferred<OpReportType[]>()

        defered.resolve(list)

        return defered.promise()
    }
}